import { analysisDisplayText } from '../utils/analysisDisplayText';
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog.jsx';
import { Button } from './ui/button';
import { CheckCircle, XCircle, AlertCircle, Info } from 'lucide-react';

const NotificationModal = ({ isOpen, onClose, type = 'info', title, message }) => {
  const getIcon = () => {
    switch (type) {
      case 'success':
        return <CheckCircle className="h-6 w-6 text-green-600" />;
      case 'error':
        return <XCircle className="h-6 w-6 text-red-600" />;
      case 'warning':
        return <AlertCircle className="h-6 w-6 text-yellow-600" />;
      default:
        return <Info className="h-6 w-6 text-blue-600" />;
    }
  };

  const getColorClasses = () => {
    switch (type) {
      case 'success':
        return {
          bg: 'bg-green-50',
          border: 'border-green-300',
          text: 'text-green-900',
          button: '#10b981'
        };
      case 'error':
        return {
          bg: 'bg-red-50',
          border: 'border-red-300',
          text: 'text-red-900',
          button: '#ef4444'
        };
      case 'warning':
        return {
          bg: 'bg-yellow-50',
          border: 'border-yellow-300',
          text: 'text-yellow-900',
          button: '#f59e0b'
        };
      default:
        return {
          bg: 'bg-blue-50',
          border: 'border-blue-300',
          text: 'text-blue-900',
          button: '#3b82f6'
        };
    }
  };

  const colors = getColorClasses();

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-[450px]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
            {getIcon()}
            {analysisDisplayText(title) || (type === 'success' ? 'Success' : type === 'error' ? 'Error' : type === 'warning' ? 'Warning' : 'Information')}
          </DialogTitle>
          <DialogDescription className="sr-only">
            {type === 'success' ? 'Success notification' : type === 'error' ? 'Error notification' : type === 'warning' ? 'Warning notification' : 'Information notification'}
          </DialogDescription>
        </DialogHeader>
        
        <div className="py-4">
          <div className={`p-4 ${colors.bg} border ${colors.border} rounded-lg`}>
            <p className={`text-sm ${colors.text} whitespace-pre-wrap`}>{analysisDisplayText(message)}</p>
          </div>
        </div>
        
        <div className="flex justify-end">
          <Button 
            onClick={onClose}
            style={{ background: colors.button }}
            className="text-white"
          >
            OK
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default NotificationModal;
